module.exports = __webpack_public_path__ + "static/outbound-foundation-7a95f029158a89380fddabdfe2ef9e6d.png";